import { Buttons } from "@/Slice"
import { ServiceAccordions } from "@/Slice/Accordions"
import { CtaButtons } from "@/Slice/CtaButtons"
import { InfoLabels } from "@/Slice/InfoLabels"
import { ServicePageContent } from "@/Slice/ServicePageContent"
import { ServicePageDocument } from "@/lib/prismicio/types.generated"
import { CookieDeclaration } from "@jog/react-components"
import { PropsWithChildren } from "react"

export const SliceRender = ({ slices }: PropsWithChildren<{ slices: ServicePageDocument["data"]["body"] }>) => (
    <div className="w-full overflow-auto bg-white py-8.75 px-6.25 text-15">
        {[...slices]
            .filter((slice) => !slice.primary.is_hide_module)
            .map((slice, index) => (
                <Slice key={index} slice={slice} />
            ))}
    </div>
)
const BASE_MARGIN = ""

export const Slice = ({ slice }: PropsWithChildren<{ slice: ServicePageDocument["data"]["body"][number] }>) => {
    switch (slice.slice_type) {
        case "service_page_content": {
            return <ServicePageContent className={BASE_MARGIN} slice={slice} />
        }
        case "info_labels": {
            return <InfoLabels className={BASE_MARGIN} slice={slice} />
        }
        case "cta_buttons": {
            return <CtaButtons className={BASE_MARGIN} slice={slice} />
        }
        case "accordions": {
            return <ServiceAccordions className={BASE_MARGIN} slice={slice} />
        }
        case "cookie_declaration": {
            return <CookieDeclaration className={BASE_MARGIN} />
        }
        case "buttons": {
            return <Buttons className={BASE_MARGIN} slice={slice} />
        }
        default: {
            return <></>
        }
    }
}
